import { createFileRoute } from "@tanstack/react-router";
import { DesktopPage } from "@/features/settings/you-pages";

export const Route = createFileRoute("/_app/settings/desktop")({ component: DesktopPage });
